module.exports = __webpack_public_path__ + "static/media/dynamic.e1a00bdc.png";